import initCounter from './counter';

document.querySelectorAll('[data-anw-counter]').forEach((element) => initCounter(element as HTMLElement));
